:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileThumbnail_z94e9_7 {
  width: 84px;
  min-width: 84px;
  height: 174px;
  background-color: #fff;
  box-shadow: -1px 2px 4px 1px rgba(43, 86, 114, 0.17), -3px 3px 18px 2px rgba(43, 86, 114, 0.13);
  border: 2px solid transparent;
  position: relative;
  border-radius: 4px;
  transition: transform 0.2s; }
  ._mobileThumbnail_z94e9_7:hover {
    transform: scale(1.03); }
  ._mobileThumbnail_z94e9_7._mobileThumbnailSelected_z94e9_19 {
    position: relative;
    border-color: #116dff;
    border-radius: 4px; }
    ._mobileThumbnail_z94e9_7._mobileThumbnailSelected_z94e9_19 ._mobileThumbnailDeviceButton_z94e9_23 {
      background-color: #d6e6fe; }
  ._mobileThumbnail_z94e9_7 ._mobileThumbnailScreen_z94e9_25 {
    width: 76px;
    height: 136px;
    background-color: #e7f0ff;
    position: absolute;
    top: 14px;
    left: 4px; }
    ._mobileThumbnail_z94e9_7 ._mobileThumbnailScreen_z94e9_25 ._mobileThumbnailImage_z94e9_32 {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
      top: 0;
      border: 0; }
  ._mobileThumbnail_z94e9_7 ._mobileThumbnailDeviceButton_z94e9_23 {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #e7f0ff;
    position: absolute;
    bottom: 6px;
    left: 50%;
    transform: translateX(-50%); }
  ._mobileThumbnail_z94e9_7 > ._selectedVSign_z94e9_49 {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate3d(50%, -50%, 0); }
